import WizardPagetemplate from '../../templates/WizardPagetemplate';
import { Button, Link, LoadingDots, PageHeader } from '@flos/react-ui';
import LandingPageHeaderTable from './components/LandingPageHeaderTable';
import LandingBackButton from './components/LandingBackButton';
import { useCallback, useEffect, useState } from 'react';
import CallMeModal from '../../shared_components/CallMeModal/CallMeModal';
import { useHippoText } from '../../hooks/useHippoText';
import { jobAtom } from '../../recoil/atoms/jobAtom';
import { useRecoilValue } from 'recoil';
import {
    ACCEPTED,
    BOUND,
    DEFAULT_PAGE,
    EXPIRED,
    QUOTED,
    SHOULD_NAVIGATE
} from '../../recoil/types/types';
import type { WizardPageComponent } from '../../config/wizardPagesConfig';
import useWizardNavigation from '../../hooks/useWizardNavigation';
import { sortedCoverablesListSelector } from '../../recoil/selectors/sortedCoverablesListSelector';
import { trackAddProduct } from '../../utils/trackingUtil';
import { useAsyncRecoilValue } from '../../hooks/useAsyncRecoilValue';
import { allHippoCoverageTextsSelector } from '../../recoil/selectors/allHippoCoverageTextsSelector';
import { accountHolderAtom } from '../../recoil/atoms/accountHolderAtom';

const LandingPage: WizardPageComponent = () => {
    const { wizardStep, wizardGotoStep, wizardNextStep, wizardPreviousStep } =
        useWizardNavigation();
    const params = new URLSearchParams(window.location.search);
    const isFromMitTopdanmark = !params.has('external');
    const [showModal, setShowModal] = useState(false);
    const getHippoText = useHippoText();
    const { sortedCoverables } = useRecoilValue(sortedCoverablesListSelector);
    const { jobStatus, isPendingCompletion, isOpcJob } = useRecoilValue(jobAtom);
    const { isCVR } = useRecoilValue(accountHolderAtom);
    const [isLoading, setIsLoading] = useState(true);

    // Prefetch coverage hippo texts
    useAsyncRecoilValue(allHippoCoverageTextsSelector);

    const navigateToPageInDA = useCallback((): void => {
        if (jobStatus === EXPIRED) {
            wizardGotoStep('ExpiredPage');
        } else if (jobStatus === ACCEPTED && !isPendingCompletion) {
            wizardGotoStep('CheckoutPage');
        } else if (jobStatus === BOUND || isPendingCompletion) {
            wizardGotoStep('ReceiptPage');
        } else if (jobStatus === QUOTED && isOpcJob) {
            wizardGotoStep('CheckoutPage');
        }
        setIsLoading(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        navigateToPageInDA();
    }, [navigateToPageInDA]);

    const onNextClick = (): void => {
        sortedCoverables.forEach((product) => {
            trackAddProduct(product);
        });
        wizardNextStep();
    };

    if (SHOULD_NAVIGATE.includes(jobStatus) && wizardStep === DEFAULT_PAGE) {
        return <></>;
    }

    if (isLoading) {
        return <LoadingDots />;
    }

    return (
        <WizardPagetemplate
            hidePrevious
            hideNext
            onNext={wizardNextStep}
            onPrevious={wizardPreviousStep}
            showGiftCertificateBanner={false}
        >
            <LandingBackButton isFromMitTopdanmark={isFromMitTopdanmark} />
            <PageHeader
                align="center"
                style={{ marginLeft: -16, marginRight: -16 }} // Only way to counteract the padding. Ulrich approved.
                title={getHippoText(
                    isCVR ? 'DSS-LANDING-PAGE-CVR-HEADER' : 'DSS-LANDING-PAGE-HEADER'
                )}
                subtitle={
                    <div className="paragraph--large">
                        <span>{getHippoText('DSS-LANDING-PAGE-SUBHEADER')} </span>
                        <Link
                            className="u-color-primary-2-base"
                            onClick={() => {
                                setShowModal(true);
                            }}
                        >
                            {getHippoText('DSS-LANDING-PAGE-SUBHEADER-CONTACTUS')}
                        </Link>
                    </div>
                }
            >
                <Button minWidth="widest" onClick={onNextClick}>
                    Fortsæt
                </Button>
            </PageHeader>
            <LandingPageHeaderTable />
            {showModal && (
                <CallMeModal
                    activityCode="dss_call_request"
                    showModal={showModal}
                    closeModal={() => {
                        setShowModal(false);
                    }}
                />
            )}
        </WizardPagetemplate>
    );
};

export default LandingPage;
